<template>
    <b-container fluid class="overview">
        <!-- Overview Table -->
        <div>
            <h4>{{ this.$t('dataImport.overview', [format]) }}</h4>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onDetails"
                :sort-by.sync="sortBy"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecords"
                :fields="fields"
                sort-icon-left
                :sort-desc="true"
            >
            </b-table>
            <p v-if="!loading && dataLoaded" class="font-italic">
                {{ this.$t('dataImport.uploadOverview') }}
            </p>
            <p v-if="!loading && !dataLoaded">
                {{ this.$t('dataImport.noUploads') }}
            </p>
            <b-spinner
                v-if="loading"
                small
                class="mx-2"
                style="align-self: center"
                label="Loading"
            />
        </div>
    </b-container>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import { dataImportStatus } from '../../services/utilities';

    export default {
        name: 'DataImportOverview',

        mixins: [modalMixin],

        props: { format: { type: String, required: true } },

        data: function () {
            return {
                fields: [
                    {
                        key: 'id',
                        label: 'Id',
                        sortable: true
                    },
                    {
                        key: 'userName',
                        label: this.$t('dataImport.userName'),
                        sortable: true
                    },
                    {
                        key: 'fileName',
                        label: this.$t('dataImport.fileName'),
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: this.$t('dataImport.status'),
                        sortable: true,
                        formatter: (value) => {
                            return dataImportStatus(value);
                        }
                    },
                    {
                        key: 'statusUpdate',
                        label: this.$t('dataImport.statusUpdate'),
                        sortable: true,
                        formatter: (value) => {
                            return new Date(value).toLocaleString(
                                this.$store.state.userInfo.locale
                            );
                        }
                    }
                ],
                sortBy: 'id',
                records: [],
                loading: false
            };
        },

        computed: {
            dataLoaded() {
                return this.filteredRecords.length > 0;
            },

            filteredRecords() {
                return this.records.filter((r) => r.format === this.format);
            }
        },

        mounted() {
            this.$_getDataImports();
        },

        methods: {
            async $_getDataImports() {
                this.loading = true;
                // get all feedback data from the backend
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetDataImports'
                    });

                    if (result) {
                        this.records = Object.assign([], result.data);
                        this.loading = false;
                    }
                } catch (error) {
                    this.loading = false;
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            },

            $_onDetails(record) {
                this.$emit('onDetails', record.id);
            },

            $_rowClass() {
                return 'tablerow';
            },
            $_modalHidden() {
                this.dataImportId = 0;
                // reload dataimports. They may have changed.
                this.$_getDataImports();
            }
        }
    };
</script>
<style>
.width-60 {
    width: 90rem;
}
.width-10 {
    width: 10rem;
}
</style>
